export default "__VITE_ASSET__6d1085e9__"